module.exports = __webpack_public_path__ + "media/images/en/upload-deel-071abd2eb8b27d280311e8fec324add7.png";